<template lang="pug">
.content-center
  .overlay
  .back-btn.mb-2(@click="back()")
    i.fa-solid.fa-left-long
    |  {{ $t("ui.back") }} 
  template(v-if="$store.getters.language == 'cn'")
    cnContent
  template(v-else-if="$store.getters.language == 'vi'")
    viContent
  template(v-else-if="$store.getters.language == 'th'")
    thContent
  template(v-else-if="$store.getters.language == 'id'")
    idContent
  template(v-else-if="$store.getters.language == 'kr'")
    krContent
  template(v-else)
    enContent
</template>

<script>
import enContent from "@/components/mobile/rules/en/aussie-rules-football";
import cnContent from "@/components/mobile/rules/cn/aussie-rules-football";
import viContent from "@/components/mobile/rules/vi/aussie-rules-football";
import thContent from "@/components/mobile/rules/th/aussie-rules-football";
import idContent from "@/components/mobile/rules/id/aussie-rules-football";
import krContent from "@/components/mobile/rules/kr/aussie-rules-football";

export default {
  components: {
    enContent,
    cnContent,
    viContent,
    thContent,
    idContent,
    krContent
  },
  computed: {},
  methods: {
    back() {
      this.$router.push("/betting_rules");
    }
  }
};
</script>